import React from 'react';

import AppIcon from '@atlaskit/icon/core/app';

export const IntegrationsIconV2 = (): React.JSX.Element => <AppIcon label="" spacing="spacious" />;
